import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AssignedToComponent } from '../assigned-to/assigned-to.component';
import { PillComponent } from '../components/pill/pill.component';
import { RiskManagementSupplierListItemTaskComponent } from '../risk-management-supplier-list-item-task/risk-management-supplier-list-item-task.component';
import { RiskPillComponent } from '../components/risk-pill/risk-pill.component';
import { PinIconComponent } from '../components/pin-icon/pin-icon.component';
import { IRiskManagementSupplier } from '../../../interfaces/supplier-risk-management/supplier-risk-management';
import { AMPriorityEnum } from '../../../enums/am-priority.enum';
import {
  ReviewStatusChange,
  ReviewStatusChangeWithSupplier,
} from '../../../interfaces/supplier-risk-management/review-status-change';

@Component({
  selector: 'risk-management-supplier-list-item',
  standalone: true,
  imports: [
    CommonModule,
    AssignedToComponent,
    PillComponent,
    RiskManagementSupplierListItemTaskComponent,
    RiskPillComponent,
    PinIconComponent,
  ],
  templateUrl: './risk-management-supplier-list-item.component.html',
  styleUrls: ['./risk-management-supplier-list-item.component.css'],
})
export class RiskManagementSupplierListItemComponent implements OnInit {
  expandTasks: boolean = false;

  @Input() riskManagementSupplier: IRiskManagementSupplier;

  @Output() selectedSupplierChange: EventEmitter<number> = new EventEmitter<number>();
  @Output() reviewStatusChange = new EventEmitter<ReviewStatusChangeWithSupplier>();

  get currentTask() {
    return this.riskManagementSupplier.tasks[this.riskManagementSupplier.currentTaskIndex];
  }

  constructor() {}

  ngOnInit(): void {}

  selectSupplier() {
    this.selectedSupplierChange.emit(this.riskManagementSupplier.supplierId);
  }

  protected handleReviewStatusChange(reviewStatusChange: ReviewStatusChange): void {
    this.reviewStatusChange.emit({
      ...reviewStatusChange,
      supplierId: this.riskManagementSupplier.supplierId,
    });
  }

  protected trackByTaskId(index: number, task: any): number {
    return task.taskId;
  }

  protected readonly AMPriorityEnum = AMPriorityEnum;
}
